<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-12 mb-primary">
        <app-breadcrumb page-title="Calendar" />
        <div class="card card-with-shadow border-0 h-10">
          <app-overlay-loader v-if="preloader" />
          <div class="card-body">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="calendar-container">
                    <!-- Header -->
                    <div class="header">
                      <button @click="prevMonth" class="btn btn-primary">
                        <i class="fa fa-arrow-left"></i> Prev
                      </button>
                      <h2>{{ monthName }} - {{ year }}</h2>
                      <button @click="nextMonth" class="btn btn-primary">
                        Next <i class="fa fa-arrow-right"></i>
                      </button>
                    </div>

                    <div>
                      <table class="calendar-table">
                        <thead>
                          <tr>
                            <th style="width: 80px" colspan="2">WEEK</th>
                            <th v-for="day in dayNames" :key="day">
                              {{ day }}
                            </th>
                          </tr>
                        </thead>
                        <!-- 
                            Status = 1 -> Next Class
                            Status = 2 -> SC Conform
                            Status = 3 -> Early Bird
                            Status = 4 -> Normal
                            Status = 5 -> Late Charges
                            Status = 6 -> Discontinue
                            Status = 7 -> Terminated
                         -->
                        <tbody v-if="!preloader">
                          <tr
                            v-for="(item, index) in calendarData"
                            :key="index"
                          >
                            <td class="term">{{ item.term }}</td>
                            <td class="week">{{ item.week }}</td>

                            <td
                              v-for="(d, i) in item.date"
                              :key="i"
                              class="day-cell"
                              :class="[
                                  statusClass(d.status), 
                                  { 'weekend': i === 6, 
                                  'disabled-day': d.day === 0 }
                                  ]"
                              :style="{ color: d.color_date }"
                              @click="d.day !== 0 && setDate(d.day)"
                            >
                              <span v-if="d.day !== 0">{{ d.day }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row">
                      <div
                        v-for="(column, colIndex) in calendarColumns"
                        :key="colIndex"
                        class="col-md-3"
                      >
                        <div
                          v-for="(item, index) in column"
                          :key="index"
                          class="event-box"
                          :style="{
                            lineHeight: 0.8,
                            fontWeight: 600,
                            fontSize: '16px',
                            padding: '5px',
                            marginBottom: '2px',
                            color: item.color || '#fff',
                            borderRadius: '4px'
                          }"
                        >
                          {{ formatEventDate(item) }}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-form
        v-if="isAddEditModalActive"
        :form-id="formId"
        :row-data="rowData"
        :selected-url="selectedUrl"
        @close-modal="closeAddEditModal"
    />

  </div>
</template>
<script>
import ModalForm  from "./Form.vue";
export default {
  components: {
    ModalForm
  },
  data() {
    return {
      preloader: false,
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      calendarData: [],
      calendarSetting:[],
      isAddEditModalActive : false,
      formId: 'set-date',
      selectedUrl: '',
      dayNames: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };
  },
  computed: {
    monthName() {
      return this.monthNames[this.month - 1];
    },
    calendarColumns() {
      const chunkSize = 5;
      const chunks = [];
      for (let i = 0; i < this.calendarSetting.length; i += chunkSize) {
        chunks.push(this.calendarSetting.slice(i, i + chunkSize));
      }
      return chunks;
    }
  },
  
  methods: {
      
    closeAddEditModal() {
        let m_id = `#set-date`;
        $(m_id).modal('hide');
        this.isAddEditModalActive = false;
        this.reSetData();
    },
    setDate(day) {
      if (day === 0) return 
      
      this.rowData = {
        day: day,
        month: this.month,
        year: this.year,
        full_date: `${this.year}-${this.month}-${day}`
      };
      this.selectedUrl = `/calendar/getSettingDate?date=${this.year}-${this.month}-${day}`;
      this.isAddEditModalActive = true;

      this.$nextTick(() => {
        $('#set-date').modal('show');
      });
    },
    statusClass(status) {
      switch (status) {
        case 1:
          return "next-class";
        case 2:
          return "sc-conform";
        case 3:
          return "early-bird";
        case 4:
          return "normal";
        case 5:
          return "late-charges";
        case 6:
          return "discontinue";
        case 7:
          return "terminated";
        default:
          return "";
      }
    },
    async loadCalendar() {
      this.preloader = true;
      const res = await axios.get("/getCalendar", {
        params: { month: this.month, year: this.year },
      });

      this.calendarData = res.data.data.setting;
      this.calendarSetting = res.data.data.event_list;
      this.preloader = false;
    },
    prevMonth() {
      this.month--;
      if (this.month < 1) {
        this.month = 12;
        this.year--;
      }
      this.loadCalendar();
    },
    nextMonth() {
      this.month++;
      if (this.month > 12) {
        this.month = 1;
        this.year++;
      }
      this.loadCalendar();
    },
    
    reSetData() {
        this.loadCalendar();

        this.rowData = null;
        this.inputs = {
            id: '',
            from_date: '',
            to_date: '',
            color: '',
            description: ''
        };
    },
    formatEventDate(item) {
      if (!item.from_date || !item.to_date) return '';

      const from = new Date(item.from_date);
      const to = new Date(item.to_date);

      const options = { day: 'numeric', month: 'short' };

      const formatDate = (date) => {
        const d = date.getDate();
        const m = date.toLocaleString('en-US', { month: 'short' });
        return `${d} ${m}`;
      };

      if (item.from_date === item.to_date) {
        return `${formatDate(from)} : ${item.description}`;
      } else {
        return `${formatDate(from)} - ${formatDate(to)} : ${item.description}`;
      }
    }
  },
  mounted() {
    this.loadCalendar();
  },
};
</script>


<style scoped>
.calendar-container {
  max-width: 1700px;
  margin: auto;
  font-family: sans-serif;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.nav-btn {
  padding: 6px 14px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.calendar-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  background: white;
}

.calendar-table th,
.calendar-table td {
  border: 1px solid #ddd;
  padding: 10px;
}

.calendar-table th {
  padding: 18px;
}
.calendar-table thead {
  background: #007bff;
  font-weight: bold;
  color: white;
}

.week,
.term {
  background: #fafafa;
  font-weight: 600;
}

.day-cell {
  height: 50px;
}

.day-cell.next-class {
  background-color: #d4efff;
}

.day-cell.sc-conform {
  background-color: #9abdff;
}
.day-cell.early-bird {
  background-color: #fff3b0;
}

.day-cell.normal {
  background-color: #c7f2c7;
}

.day-cell.late-charges {
  background-color: #f7c6c6;
}

.day-cell.discontinue {
  background-color: #d06c6c;
}

.day-cell.terminated {
  background-color: red;
}
.weekend{
  color: #ee1414;
  font-weight:600;
}
.disabled-day {
  cursor: no-drop;
}
@media (min-width: 1800px) {
  .calendar-table th {
    padding: 25px;
    font-size: 20px;
  }
  .calendar-table td {
    padding: 22px;
    font-size: 18px;
  }
  .btn-primary {
    font-size: 20px;
  }
  .calendar-table span {
    font-size: 18px;
  }
}
</style>
